import React from "react";
import { useRenderOn } from "src/hooks";
import styled from "styled-components";

import theme, { media } from "../../../../../theme";

import FooterMobile from "./components/FooterMobile";
import FooterTablet from "./components/FooterTablet";
import HealthSection from "./components/HealthSection";

const Wrapper = styled.footer`
  border-top: solid 1px ${theme.colors.lightGrey};
  padding: 0 ${theme.margins.marginBig};
  background-color: ${theme.colors.white};

  ${media.laptop} {
    padding: 0;
  }
`;

interface IStickyWrapper {
  isSticky: boolean;
}

const StickyWrapper = styled.div`
  ${(props: IStickyWrapper): string =>
    props.isSticky
      ? `
      position: sticky;
      bottom: 0;
      z-index: 10;
      `
      : ""}
`;

interface IProps {
  preventStickyInFooter?: boolean;
}

const Footer = ({ preventStickyInFooter = false }: IProps): JSX.Element => {
  const { mdOrDown } = useRenderOn();

  return (
    <>
      <Wrapper>{mdOrDown ? <FooterMobile /> : <FooterTablet />}</Wrapper>
      <StickyWrapper isSticky={!preventStickyInFooter}>
        <HealthSection />
      </StickyWrapper>
    </>
  );
};

export default Footer;
